
import { Component, Vue } from 'vue-property-decorator';
import { PERMISSION } from '@/permissions';
import { Getter } from 'vuex-class';
import AddOnsList from '@/components/AddOnsList.vue';
import EditMenus from '@/components/menu/EditMenus.vue';
import ReplicateMenus from '@/components/menu/ReplicateMenus.vue';
import TagsManager from '@/components/menu/TagsManager.vue';
import SuitesHeader from '@/components/shared/suites/SuitesHeader.vue';
import Tabs from '@/components/shared/Tabs.vue';

const namespace: string = 'auth';

@Component<Menus>({
	components: {
		AddOnsList,
		EditMenus,
		ReplicateMenus,
		TagsManager,
		SuitesHeader,
		Tabs
	}
})

export default class Menus extends Vue {
	@Getter('getTenantId', { namespace }) private tenantId!: string;
	@Getter('getRestaurants', { namespace }) private restaurants!: Tenant[];
	@Getter('hasPermission', { namespace }) private hasPermission!: (permission: PERMISSION) => boolean;

	private PERMISSION = PERMISSION;
	private loading: boolean = false;

	$refs!: {
		tabs: Tabs;
		editMenus: EditMenus;
	};

	private get tabs(): Tab[] {
		return [
			{ key: 'edit-menus', label: this.$t('menu.tabs.edit_menus') },
			{ key: 'modifiers', label: this.$t('menu.tabs.modifiers') },
			{ key: 'replicate-menus', label: this.$t('menu.tabs.replicate'), hidden: !this.showReplicateMenus },
			{ key: 'tags', label: this.$t('menu.tabs.tags'), hidden: !this.hasPermission(PERMISSION.CREATE_TAGS) }
		];
	}

	private get activeTab(): Tab | undefined {
		const key = this.$refs.tabs?.activeTabKey;
		return key ? this.tabs.find(tab => tab.key === key) : undefined;
	}

	private get restaurant(): Tenant | undefined {
		return this.restaurants.find((restaurant) => restaurant.id === this.tenantId);
	}

	private get showReplicateMenus(): boolean {
		return this.hasPermission(PERMISSION.REPLICATE) && (this.restaurants && this.restaurants.length > 1);
	}

	private get initialTab(): string {
		const hash = window.location.hash.replace('#', '');
		const tab = this.tabs.find(tab => tab.key === hash && !tab.hidden);
		return tab ? tab.key : this.tabs[0].key;
	}

	/**
	 * Update the hash in the URL when the tab changes
	 * If the tab is the top-level tab, reset the selected section/menu
	 *
	 * @param {Tab} tab
	 * @return {void}
	 */
	private handleTabChange(tab: Tab): void {
		if (tab.key !== 'edit-menus') {
			this.$router.push(`/menus#${tab.key}`).catch(() => {});
		}
		else if (this.$refs.editMenus) {
			this.$router.push('/menus').catch(() => {});
		}
	}
}
